// extracted by mini-css-extract-plugin
module.exports = {"root":"EventDetailTickets_root__C4NA3","notFoundText":"EventDetailTickets_notFoundText__ci2sx"};